const state = {}
const getters = {
  dark (state, getters, rootState) {
    return rootState.$L.dark
  },
  isDevelopment (state, getters, rootState) {
    return process.env.NODE_ENV !== 'production' || rootState.$L.developerMode
  },
  platform (state, getters, rootState) {
    return rootState.$L.platform
  },
}
const actions = {
  setDark ({commit}, val) {
    commit('$L/setDark', val, {root: true})
  },
  routerInTab ({commit}) {
    commit('$L/routerInTab', null, {root: true})
  },
  alert ({commit}, attr) {
    commit('$L/openAlert', attr, {root: true})
  },
  closeAlert ({commit}) {
    commit('$L/closeAlert', null, {root: true})
  },
  confirm ({commit}, attr) {
    // console.log('confirm option')
    return new Promise((resolve, reject) => {
      commit('$L/openOperation', {
        ...attr,
        onCancel: r => {
          resolve({res: false, close: r})
        },
        onConfirm: r => {
          resolve({res: true, close: r})
        }
      }, {root: true})
    })
  }
}
const mutations = {}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
